import { CONSTANTS } from "./constants";
import { NewsSocialFeedV2 } from 'm360-react-components';
import { ArticleShowFour } from 'm360-react-components';
import { LeadImageArticleShow } from 'm360-react-components';
import { BreakingNews, BreadCrumbs, BreadCrumbsAmp, GridView, ListView, Footer, FooterAmp, Header, HeaderAmp, HeroLayout, HeroLayout2, AuthorShow, PageNotFound, PageGone, VideoShow, ArticleShow, SlideShow, StaticPage, WebStories, ArticleShowAmp, BreakingNewsTwo,VideoCarousel,VideoCarouselCenter, QuickViewTwo, ListViewTwo,ListViewAlt, HomeGridViewTwo, WebStoriesTwo, HeroLayoutTwo,HeroLayoutInverted, HeroLayoutHrTwo, RhsHomeTwo,HomeCardList, NewsSocialFeed, MainMenuFour, WebstoriesListFour, ContentTagsList, PollCard, DynamicList, DynamicForm, HeaderFour, QuizListFour, QuizShowFour, GridViewTwo, WebStoriesListTwo, MediaListTwo, PhotoListTwo, ArticleShowTwo,ContentRestrictionsTwo,liveBlog, ampLiveBlog,VideoShowTwo, SlideShowTwo, FooterTwo, HeaderTwo, BreadCrumbsTwo, AuthorShowTwo, StaticPageTwo, PageNotFoundTwo, PageGoneTwo, RhsHomeOtherTwo, ArticleShowTwoAmp, HeaderTwoAmp, FooterTwoAmp, BreadCrumbsTwoAmp, PhotoShowTwoAmp, VideoShowTwoAmp, BreakingNewsTicker, PodcastTwo, BreakingNewsThreeTicker, QuickViewThree, ListViewThree, HomeGridViewThree, WebStoriesThree, WebStoriesListThree, HeroLayoutThree, RhsHomeThree, RhsHomeOtherThree, GridViewThree, MediaListThree, PhotoListThree, ArticleShowThree, VideoShowThree, PodcastThree, SlideShowThree, FooterThree, HeaderThree, BreadCrumbsThree, AuthorShowThree, StaticPageThree, PageNotFoundThree, PageGoneThree, ArticleShowThreeAmp, HeaderThreeAmp, FooterThreeAmp, BreadCrumbsThreeAmp, PhotoShowThreeAmp, VideoShowThreeAmp, HeroLayoutwithHeader, FourLinks, HomeWebStories, HomeFaq, FaqList, OtherListView, Experts, QuizShow, SurveyShow, AddScripts, GutterAds, RhsWight, VideoReel, QuizRelatedFour, VerticalListFour, HorizontalListFour, ImmersiveStory} from 'm360-react-components';
// import ScriptsComponent from "../components/ScriptsComponent/ScriptsComponent.js";
// import SlideShow from "../components/SlideShow/SlideShow.js";
// import AddScripts from "../components/AddScripts/AddScripts.js";
// import AddScriptsTwo from "../components/AddScriptsTwo/AddScriptsTwo.js";
// import AddScriptsThree from "../components/AddScriptsThree/AddScriptsThree.js";
import createComponentJson from "./component-list.js";
import { HtmlPageHandler } from 'm360-react-components';
import { htmlPageHandlerDefinition } from '../html-page-layouts';
import { getSessionObject } from "./Utils.js";

// import StaticPage from "../components/StaticPage/StaticComponent";


export const theme_components = [
  { themeId: [], component: HtmlPageHandler, uniqueName: 'HTML Page Handler', displayName: 'HTML Page Handler' },

  {
    themeId: [3],
    component: Header,
    uniqueName: "Header",
    displayName: "Header"
  },
  // {
  //   themeId: [4, 6],
  //   component: Header,
  //   uniqueName: "Header",
  //   displayName: "Header 2"
  // },
  {
    themeId: [3],
    component: ListView,
    uniqueName: "List View",
    displayName: "List View"
  },
  // {
  //   themeId: [4, 6],
  //   component: BreakingNews,
  //   uniqueName: "Breaking News",
  //   displayName: "Breaking News 19"
  // },
  {
    themeId: [3],
    component: BreakingNews,
    uniqueName: "Breaking News",
    displayName: "Breaking News"
  },
  {
    themeId: [4, 6],
    component: VideoCarousel,
    uniqueName: "Video Carousel",
    displayName: "Carousel - Video"
  },
    {
    themeId: [4, 6],
    component: VideoCarouselCenter,
    uniqueName: "Video Carousel Center",
    displayName: "Carousel - CenterStage"
  },
      {
    themeId: [4, 6],
    component: VideoReel,
    uniqueName: "Video Reel",
    displayName: "Carousel - Video Shorts View"
  },
    {
    themeId: [4, 6],
    component: BreakingNewsTwo,
    uniqueName: "Breaking News Two",
    displayName: "Carousel - Trending News"
  },
  {
    themeId: [4, 6],
    component: BreakingNewsTicker,
    uniqueName: "Breaking News Ticker",
    displayName: "Ticker - Breaking News"
  },
  {
    themeId: [4, 6],
    component: QuickViewTwo,
    uniqueName: "Quick View Two",
    displayName: "Carousel - Landscape Card"
  },
  {
    themeId: [4, 6],
    component: ListViewTwo,
    uniqueName: "List View Two",
    displayName: "List View Vertical"
  },
    {
    themeId: [4, 6],
    component: ListViewAlt,
    uniqueName: "List View Alt",
    displayName: "List View Horizonal"
  },
  {
    themeId: [4, 6],
    component: HomeGridViewTwo,
    uniqueName: "Home Grid View Two",
    displayName: "Content View"
  },
  {
    themeId: [4, 6],
    component: WebStoriesTwo,
    uniqueName: "WebStories Two",
    displayName: "Carousel - Webstory Cards"
  },
  {
    themeId: [4, 6],
    component: WebStoriesListTwo,
    uniqueName: "WebStoriesList Two",
    displayName: "Webstories - Listing"
  },

  {
    themeId: [4, 6],
    component: HeroLayoutTwo,
    uniqueName: "HeroLayout Two",
    displayName: "Hero Layout - LHS"
  },
    {
    themeId: [4, 6],
    component: HeroLayoutInverted,
    uniqueName: "HeroLayout Inverted",
    displayName: "Hero Layout - RHS"
  },
  {
    themeId: [4, 6],
    component: HeroLayoutHrTwo,
    uniqueName: "HeroLayout Hr Two",
    displayName: "Hero Layout - HR"
  },
  {
    themeId: [4, 6],
    component: RhsHomeTwo,
    uniqueName: "RhsHome Two",
    displayName: "RHS Layout - without Title"
  },
    {
    themeId: [4, 6],
    component: HomeCardList,
    uniqueName: "HomeCard List",
    displayName: "Content List"
  },
  {
    themeId: [4, 6],
    component: NewsSocialFeed,
    uniqueName: "News Social Feed",
    displayName: "News Social Feed"
  },
  {
    themeId: [4, 6],
    component: NewsSocialFeedV2,
    uniqueName: "News Social Feed V2",
    displayName: "News Social Feed V2"
  },
  {
    themeId: [4, 6],
    component: VerticalListFour,
    uniqueName: "Vertical List Four",
    displayName: "Vertical List Four"
  },
  {
    themeId: [4, 6],
    component: HorizontalListFour,
    uniqueName: "Horizontal List Four",
    displayName: "Horizontal List Four"
  },
  {
    themeId: [4, 6],
    component: MainMenuFour,
    uniqueName: "Main Menu Four",
    displayName: "Main Menu Four"
  },
  {
    themeId: [4, 6],
    component: WebstoriesListFour,
    uniqueName: "Webstories List Four",
    displayName: "Webstories List Four"
  },
  {
    themeId: [4, 6],
    component: ContentTagsList,
    uniqueName: "Content Tags List",
    displayName: "Content Tags List"
  },
  {
    themeId: [4, 6],
    component: PollCard,
    uniqueName: "Poll Card",
    displayName: "Poll Card"
  },
  {
    themeId: [4, 6],
    component: DynamicList,
    uniqueName: "Dynamic List",
    displayName: "Dynamic List"
  },
  {
    themeId: [3, 4, 5, 6, 19],
    component: DynamicForm,
    uniqueName: "Dynamic Form",
    displayName: "Dynamic Form"
  },
  {
    themeId: [4, 6],
    component: HeaderFour,
    uniqueName: "Header Four",
    displayName: "Header Four"
  },
  {
    themeId: [4, 6],
    component: QuizListFour,
    uniqueName: "Quiz List Four",
    displayName: "Quiz List Four"
  },
  {
    themeId: [4, 6],
    component: QuizRelatedFour,
    uniqueName: "Quiz Related Four",
    displayName: "Quiz Related Four"
  },
  {
    themeId: [4, 6],
    component: QuizShowFour,
    uniqueName: "Quiz Show Four",
    displayName: "Quiz Show Four"
  },
  {
    themeId: [4, 6],
    component: QuizShowFour,
    uniqueName: "Survey Show Four",
    displayName: "Survey Show Four"
  },
  {
    themeId: [4, 6],
    component: RhsHomeOtherTwo,
    uniqueName: "RhsHome Other Two",
    displayName: "RHS Layout - with Title"
  },

  {
    themeId: [4, 6],
    component: RhsWight,
    uniqueName: "Rhs Wight",
    displayName: "Widget"
  },

  {
    themeId: [4, 6],
    component: GridViewTwo,
    uniqueName: "GridView Two",
    displayName: "Media - Grid View - 3 Coloum"
  },
  // {
  //   themeId: [4, 6],
  //   component: GridViewTwo,
  //   uniqueName: "GridView Other Two",
  //   displayName: "GridView Other"
  // },
  {
    themeId: [4, 6],
    component: MediaListTwo,
    uniqueName: "MediaList Two",
    displayName: "Media - List View - 5 Coloum"
  },
  {
    themeId: [4, 6],
    component: PhotoListTwo,
    uniqueName: "PhotoList Two",
    displayName: "Photo List - 4 Coloum"
  },
  {
    themeId: [4, 6],
    component: ArticleShowTwo,
    uniqueName: "Article Show Two",
    displayName: "Article Show"
  },
  {
    themeId: [4, 6],
    component: ArticleShowFour,
    uniqueName: "Article Show Four",
    displayName: "Article Show Four"
  },
  {
    themeId: [4, 6],
    component: LeadImageArticleShow,
    uniqueName: "Lead Image Article Show",
    displayName: "Lead Image Article Show"
  },
  {
    themeId: [4, 6],
    component: liveBlog,
    uniqueName: "Liveblog Show Two",
    displayName: "Live Blog"
  },
    {
    themeId: [4, 6],
    component: ampLiveBlog,
    uniqueName: "Amp Liveblog Show Two",
    displayName: "Live Blog"
  },
  {
    themeId: [4, 6],
    component: VideoShowTwo,
    uniqueName: "Video Show Two",
    displayName: "Video Show"
  },
  {
    themeId: [19, 4, 6],
    component: PodcastTwo,
    uniqueName: "Podcast Two",
    displayName: "Podcast"
  },
  {
    themeId: [19, 4, 6],
    component: SlideShowTwo,
    uniqueName: "Slide Show Two",
    displayName: "Slide Show"
  },
  {
    themeId: [4, 6],
    component: FooterTwo,
    uniqueName: "Footer Two",
    displayName: "Footer"
  },
  {
    themeId: [4, 6],
    component: HeaderTwo,
    uniqueName: "Header Two",
    displayName: "Header - Layout One "
  },

  {
    themeId: [4, 6],
    component: BreadCrumbsTwo,
    uniqueName: "BreadCrumbs Two",
    displayName: "BreadCrumbs"
  },
  {
    themeId: [4, 6],
    component: AddScripts,
    uniqueName: "Ad Scripts Two",
    displayName: "Ad Scripts"
  },
  {
    themeId: [4, 6],
    component: AddScripts,
    uniqueName: "Ad Scripts Two Amp",
    displayName: "Ad Scripts"
  },
  {
    themeId: [3],
    component: ArticleShow,
    uniqueName: "Article Show",
    displayName: "Article Show"
  },
  {
    themeId: [3],
    component: GridView,
    uniqueName: "Grid View",
    displayName: "Grid View"
  },
  {
    themeId: [3],
    component: GridView,
    uniqueName: "Grid View2",
    displayName: "Grid View Other"
  },
  {
    themeId: [3],
    component: Footer,
    uniqueName: "Footer",
    displayName: "Footer"
  },
  {
    themeId: [3],
    component: ListView,
    uniqueName: "Similar Stories",
    displayName: "Similar Stories"
  },
  {
    themeId: [3],
    component: BreadCrumbs,
    uniqueName: "Bread Crumbs",
    displayName: "BreadCrumbs"
  },
  {
    themeId: [3],
    component: GridView,
    uniqueName: "Carousel Card Block",
    displayName: "Carousel - Card Block"
  },
  {
    themeId: [3],
    component: GridView,
    uniqueName: "Circular Card Carousel",
    displayName: "Carousel - Circular Card "
  },
  {
    themeId: [3],
    component: HeroLayout,
    uniqueName: "Hero Layout",
    displayName: "Hero Layout"
  },
  {
    themeId: [3],
    component: HeroLayout2,
    uniqueName: "Hero Layout2",
    displayName: "Hero Layout2"
  },
  {
    themeId: [3],
    component: AuthorShow,
    uniqueName: "Author Show",
    displayName: "Author Show"
  },
  {
    themeId: [4, 6],
    component: AuthorShowTwo,
    uniqueName: "Author Show Two",
    displayName: "Author Show"
  },
  {
    themeId: [4, 6],
    component: StaticPageTwo,
    uniqueName: "Static Page Two",
    displayName: "Static Page"
  },
  {
    themeId: [4, 6],
    component: PageNotFoundTwo,
    uniqueName: "Page Not Found Two",
    displayName: "Static Page - 404 Error"
  },
  {
    themeId: [4, 6],
    component: PageGoneTwo,
    uniqueName: "Page Gone Two",
    displayName: "Static Page - 410 Gone"
  },

    {
    themeId: [4, 6],
    component: ContentRestrictionsTwo,
    uniqueName: "ContentRestrictionsTwo",
    displayName: "Geo Restriction - Content"
  },

  {
    themeId: [4, 6],
    component: ArticleShowTwoAmp,
    uniqueName: "Article Show Two Amp",
    displayName: "ArticleShow"
  },
  {
    themeId: [4, 6],
    component: HeaderTwoAmp,
    uniqueName: "Header Two Amp",
    displayName: "Header"
  },
  {
    themeId: [4, 6],
    component: FooterTwoAmp,
    uniqueName: "Footer Two Amp",
    displayName: "Footer"
  },
  {
    themeId: [4, 6],
    component: BreadCrumbsTwoAmp,
    uniqueName: "Bread Crumbs Two Amp",
    displayName: "BreadCrumbs"
  },
  {
    themeId: [4, 6],
    component: PhotoShowTwoAmp,
    uniqueName: "Photo Show Two Amp",
    displayName: "Photo Show"
  },
  {
    themeId: [4, 6],
    component: VideoShowTwoAmp,
    uniqueName: "Video Show Two Amp",
    displayName: "Video Show"
  },



  {
    themeId: [3],
    component: VideoShow,
    uniqueName: "Video Show",
    displayName: "Video Show"
  },
  {
    themeId: [3],
    component: PageNotFound,
    uniqueName: "Page Not Found",
    displayName: "Page Not Found"
  },
  {
    themeId: [3],
    component: PageGone,
    uniqueName: "Page Gone",
    displayName: "Page Gone - 410"
  },
  {
    themeId: [3],
    component: AddScripts,
    uniqueName: "Ad Scripts",
    displayName: "Ad Scripts"
  },
  {
    themeId: [3],
    component: AddScripts,
    uniqueName: "Ad Scripts Amp",
    displayName: "Ad Scripts"
  },
  {
    themeId: [3, 4, 5, 6],
    component: GutterAds,
    uniqueName: "Left Gutter Ads",
    displayName: "Gutter Ads - Left"
  },
  {
    themeId: [3, 4, 5, 6],
    component: GutterAds,
    uniqueName: "Right Gutter Ads",
    displayName: "Gutter Ads - Right"
  },
  {
    themeId: [3, 4, 5, 6],
    component: ImmersiveStory,
    uniqueName: "Immersive Story",
    displayName: "Immersive Story"
  },
  {
    themeId: [3],
    component: SlideShow,
    uniqueName: "Slide Show",
    displayName: "Slide Show"
  },
  {
    themeId: [3],
    component: StaticPage,
    uniqueName: "Static Page",
    displayName: "Static Page"
  },
  {
    themeId: [3],
    component: HeaderAmp,
    uniqueName: "Header Amp",
    displayName: "Header Amp" 
  },
  {
    themeId: [3],
    component: FooterAmp,
    uniqueName: "Footer Amp",
    displayName: "Footer Amp"
  },
  {
    themeId: [3],
    component: BreadCrumbsAmp,
    uniqueName: "Bread Crumbs Amp",
    displayName: "BreadCrumbs"
  },
  {
    themeId: [3],
    component: WebStories,
    uniqueName: "Web Stories",
    displayName: "Web Stories"
  },
  {
    themeId: [3],
    component: WebStories,
    uniqueName: "Web Stories2",
    displayName: "WebStories List"
  },
  {
    themeId: [3],
    component: ArticleShowAmp,
    uniqueName: "Article Show Amp",
    displayName: "Article Show"
  },
  {
    themeId: [3],
    component: VideoShowTwoAmp,
    uniqueName: "Video Show Two Amp",
    displayName: "Video Show"
  },


  // {
  //   themeId: [5],
  //   component: BreakingNewsThree,
  //   uniqueName: "Breaking News Three",
  //   displayName: "Breaking News"
  // },

  {
    themeId: [5],
    component: FourLinks,
    uniqueName: "Four Links",
    displayName: "Four Links"
  },

  {
    themeId: [5],
    component: HomeFaq,
    uniqueName: "Home Faq",
    displayName: "Home Faq"
  },
  {
    themeId: [5],
    component: FaqList,
    uniqueName: "Faq List",
    displayName: "FaqList"
  },
  // {
  //   themeId: [5],
  //   component: HomePhotoGallery,
  //   uniqueName: "Home Photo Gallery",
  //   displayName: "Home Photo Gallery"
  // },


  {
    themeId: [5],
    component: HomeWebStories,
    uniqueName: "Home Web Stories",
    displayName: "Home Web Stories"
  },

  {
    themeId: [5],
    component: BreakingNewsThreeTicker,
    uniqueName: "Breaking News Three Ticker",
    displayName: "Breaking News Three Ticker"
  },
  {
    themeId: [5],
    component: QuickViewThree,
    uniqueName: "Quick View Three",
    displayName: "Quick View Three"
  },
  {
    themeId: [5],
    component: Experts,
    uniqueName: "Experts",
    displayName: "Experts"
  },
  {
    themeId: [5],
    component: ListViewThree,
    uniqueName: "List View Three",
    displayName: "List View Three"
  },

  // {
  //   themeId: [4, 6],
  //   component: ListViewThree,
  //   uniqueName: "List View Three",
  //   displayName: "List View Two"
  // },

  {
    themeId: [5],
    component: OtherListView,
    uniqueName: "OtherList View",
    displayName: "OtherList View"
  },
  {
    themeId: [5],
    component: HomeGridViewThree,
    uniqueName: "Home Grid View Three",
    displayName: "Home Grid View Three"
  },
  {
    themeId: [-1],
    component: WebStoriesThree,
    uniqueName: "WebStories Three",
    displayName: "WebStories Three"
  },
  {
    themeId: [5],
    component: WebStoriesListThree,
    uniqueName: "WebStoriesList Three",
    displayName: "WebStoriesList Three"
  },

  {
    themeId: [5],
    component: HeroLayoutThree,
    uniqueName: "HeroLayout Three",
    displayName: "HeroLayout Three"
  },
  // {
  //   themeId: [5],
  //   component: HeroLayoutHrThree,
  //   uniqueName: "HeroLayout Hr Three",
  //   displayName: "HeroLayout Hr Three"
  // },
  {
    themeId: [5],
    component: RhsHomeThree,
    uniqueName: "RhsHome Three",
    displayName: "RHS Layout Three"
  },
  {
    themeId: [5],
    component: RhsHomeOtherThree,
    uniqueName: "RhsHome Other Three",
    displayName: "RHS Layout Other Three"
  },
  {
    themeId: [5],
    component: GridViewThree,
    uniqueName: "GridView Three",
    displayName: "GridView Media Three"
  },
  // {
  //   themeId: [5],
  //   component: GridViewThree,
  //   uniqueName: "GridView Other Three",
  //   displayName: "GridView Other Three"
  // },
  {
    themeId: [5],
    component: MediaListThree,
    uniqueName: "MediaList Three",
    displayName: "MediaList Three"
  },
  {
    themeId: [5],
    component: PhotoListThree,
    uniqueName: "PhotoList Three",
    displayName: "PhotoList Three"
  },
  {
    themeId: [5],
    component: ArticleShowThree,
    uniqueName: "Article Show Three",
    displayName: "Article Show"
  },
  {
    themeId: [3, 4, 5, 6],
    component: QuizShow,
    uniqueName: "Quiz Show",
    displayName: "Quiz Show"
  },
  {
    themeId: [3, 4, 5, 6],
    component: SurveyShow,
    uniqueName: "Survey Show",
    displayName: "Survey Show"
  },
  {
    themeId: [5],
    component: VideoShowThree,
    uniqueName: "Video Show Three",
    displayName: "Video Show Three"
  },
  {
    themeId: [19, 5],
    component: PodcastThree,
    uniqueName: "Podcast Three",
    displayName: "Podcast Three"
  },
  {
    themeId: [19, 5],
    component: SlideShowThree,
    uniqueName: "Slide Show Three",
    displayName: "Slide Show Three"
  },
  {
    themeId: [5],
    component: FooterThree,
    uniqueName: "Footer Three",
    displayName: "Footer Three"
  },
  {
    themeId: [5, 4, 6],
    component: HeaderThree,
    uniqueName: "Header Three",
    displayName: "Header Other"
  },

  // {
  //   themeId: [4, 6],
  //   component: otherHeader,
  //   uniqueName: "other Header",
  //   displayName: "other Header"
  // },
  {
    themeId: [5],
    component: HeroLayoutwithHeader,
    uniqueName: "HeroLayout with Header",
    displayName: "HeroLayout with Header"
  },


  {
    themeId: [5],
    component: BreadCrumbsThree,
    uniqueName: "BreadCrumbs Three",
    displayName: "BreadCrumbs"
  },
  {
    themeId: [5],
    component: AddScripts,
    uniqueName: "Ad Scripts Three",
    displayName: "Ad Scripts"
  },

  {
    themeId: [5],
    component: AuthorShowThree,
    uniqueName: "Author Show Three",
    displayName: "Author Show"
  },
  {
    themeId: [5],
    component: StaticPageThree,
    uniqueName: "Static Page Three",
    displayName: "Static Page Three"
  },
  {
    themeId: [5],
    component: PageNotFoundThree,
    uniqueName: "PageNotFound Three",
    displayName: "PageNotFound Three"
  },
  {
    themeId: [5],
    component: PageGoneThree,
    uniqueName: "PageGone Three",
    displayName: "PageGone Three - 410"
  },

  {
    themeId: [5],
    component: ArticleShowThreeAmp,
    uniqueName: "Article Show Three Amp",
    displayName: "ArticleShow"
  },
  {
    themeId: [5],
    component: HeaderThreeAmp,
    uniqueName: "Header Three Amp",
    displayName: "Header Three"
  },
  {
    themeId: [5],
    component: FooterThreeAmp,
    uniqueName: "Footer Three Amp",
    displayName: "Footer Three"
  },
  {
    themeId: [5],
    component: BreadCrumbsThreeAmp,
    uniqueName: "Bread Crumbs Three Amp",
    displayName: "BreadCrumbs"
  },
  {
    themeId: [5],
    component: PhotoShowThreeAmp,
    uniqueName: "Photo Show Three Amp",
    displayName: "Photo Show Three"
  },
  {
    themeId: [5],
    component: VideoShowThreeAmp,
    uniqueName: "Video Show Three Amp",
    displayName: "Video Show Three"
  },
];


export const getComponentFromUniqueNameAndThemeId = (uniqueName, themeId) => {
  let components = theme_components.filter(o => o.uniqueName == uniqueName && (o.themeId.length == 0 || o.themeId.includes(themeId)));
  if (components && components.length == 1 && components[0]) {
    return components[0];
  }
}

export const getComponentFromNameAndThemeId = (displayName, themeId) => {
  let components = theme_components.filter(o => o.displayName == displayName && (o.themeId.length == 0 || o.themeId.includes(themeId)));
  //console.log("componentscomponentsdisplayName", components, displayName, themeId);
  if (components && components.length == 1 && components[0]) {
    return components[0];
  }
}

const setupBlockSearch = (editor) => {
  const bm = editor.BlockManager;
  let searchInput = document.getElementById('gjs-block-search-input');

  // Take reference of the container
  const container = bm.getContainer();
  if (!container || !container.parentNode) {
    // If the DOM is not loaded, try again after 250ms
    setTimeout(() => setupBlockSearch(editor), 250);
    return;
  }

  // If the search bar is not present, create a new one
  if (!searchInput) {
    searchInput = document.createElement('input');
    searchInput.id = 'gjs-block-search-input';
    searchInput.type = 'text';
    searchInput.placeholder = 'Search components...';
    
    // Apply basic styling
    Object.assign(searchInput.style, {
      width: '100%', padding: '10px', boxSizing: 'border-box',
      border: 'none', borderBottom: '1px solid rgba(0,0,0,0.15)',
      outline: 'none', display: 'block',fontSize:'16px',marginBottom:'10px'
    });

    // When the user types
    searchInput.oninput = (e) => {
      const val = e.target.value.toLowerCase().trim(); // .trim() removes extra spaces
      const isSearching = val.length >= 2;
      
      const blocks = container.querySelectorAll('.gjs-block');
      const categoryDOMs = container.querySelectorAll('.gjs-block-category');
      
      // Get GrapesJS models with cross-version compatibility
      const categoryModels = bm.getCategories().models || bm.getCategories(); 

      // 1. Filter the blocks
      blocks.forEach(blockEl => {
        if (isSearching) {
          const label = blockEl.textContent.toLowerCase();
          blockEl.style.display = label.includes(val) ? '' : 'none';
        } else {
          blockEl.style.display = ''; // If the input is less than 2 characters, show everything
        }
      });

      // 2. Handle dropdowns (categories)
      categoryDOMs.forEach((catDOM, index) => {
        if (isSearching) {
          // .some() is very fast; it stops the loop as soon as it finds the first visible block
          const hasVisibleBlocks = Array.from(catDOM.querySelectorAll('.gjs-block')).some(block => block.style.display !== 'none');

          // If visible blocks exist, show the category; otherwise hide it
          catDOM.style.display = hasVisibleBlocks ? '' : 'none';
          
          // Use GrapesJS to open the category so that clicks stay in sync
          if (hasVisibleBlocks && categoryModels[index]) {
            categoryModels[index].set('open', true);
          }
        } else {
          // If the user clears the search, reset everything
          catDOM.style.display = '';
        }
      });
    };
  }
  
  // Insert the search bar at the correct place (top of the UI)
  if (container.parentNode && searchInput.parentNode !== container.parentNode) {
    container.parentNode.insertBefore(searchInput, container);
  }

  searchInput.value = ''; // Clear the search box when the page reloads
};

export default (editor, selectedPageTemplate) => {
  if (!editor.__htmlPageHandlerProtection) {
    editor.__htmlPageHandlerProtection = true;
    const protect = (component) => {
      if (component.get('type') !== 'HTML Page Handler') return;
      component.set({ removable: false, copyable: false, draggable: false, droppable: false });
      for (let parent = component.parent(); parent && parent.get('type') !== 'wrapper'; parent = parent.parent()) {
        parent.set({ removable: false, copyable: false, draggable: false, droppable: false });
        parent.addAttributes({ htmlPageLayout: true });
      }
    };
    editor.on('component:add', protect);
    const protectExistingHtmlPageHandlers = () => {
      const wrapper = editor.getWrapper?.();
      if (wrapper?.findType) {
        wrapper.findType('HTML Page Handler').forEach(protect);
      }
    };
    // GrapesJS creates the wrapper during its load cycle, after plugins are initialized.
    editor.on('load', protectExistingHtmlPageHandlers);
    protectExistingHtmlPageHandlers();
  }
  if (editor.BlockManager.all.length > 0) {
    editor.BlockManager.clear();
  }

  createComponentJson().then((componentJson) => {
    componentJson.push(htmlPageHandlerDefinition);

    let themeId = localStorage.getItem("themeId");
    if (themeId) {
      themeId = parseInt(themeId);
    }

    const getUpdatedArr = (isAmp) => {
      let arr = [...componentJson];
      arr = isAmp ? arr.filter(val => val.name.includes("Amp")) : arr.filter(val => !val.name.includes("Amp"));
      return arr;
    }

    let isAMP = selectedPageTemplate && selectedPageTemplate.name && selectedPageTemplate.name.includes("Amp");
    let updateArr = getUpdatedArr(isAMP);

        // Category rules

        const categoryRules = [
          {
            name: "Ad Components",
            keywords: ["Ad", "Gutter", "Script"]
          },
          {
            name: "Breaking News",
            keywords: ["Ticker"]
          },
          {
            name: "Header Components",
            keywords: ["Header"]
          },
          {
            name: "Hero Layout  Components",
            keywords: ["Hero"]
          },
          {
            name: "Carousel Components",
            keywords: ["Carousel", "Reel", "Experts", "Quick", "Breaking", "WebStories Two"]
          },
          {
            name: "Content Display Components",
            keywords: ["Show", "Podcast", "Article", "Bread","ContentRestrictionsTwo", "Grid","page", "Immersive"]
          },
          {
            name: "Content Listing Components",
            keywords: ["List",  "Stories", "Related", "Rhs", "Links", "Faq"]
          },
          {
            name: "Footer Components",
            keywords: ["Footer"]
          },
          {
            name: "Others Components",
            keywords: [ ]
          }
        ];

      // Category detection function
        function getCategory(uniqueName) {
        for (const rule of categoryRules) {
          if (rule.keywords.some(keyword => uniqueName.includes(keyword))) {
            return rule.name;
          }
        }
        return "Others Components";
      }
      // Category order 
      const categoryOrder = [
        "Ad Components",
        "Breaking News",
        "Carousel Components",
        "Content Display Components",
        "Content Listing Components",
        "Footer Components",
        "Header Components",
        "Hero Layout  Components",
        "Others Components"
      ];

      // Pre-create categories fix order

    updateArr.sort((a, b) => {
      const compA = getComponentFromUniqueNameAndThemeId(a.name, themeId);
      const compB = getComponentFromUniqueNameAndThemeId(b.name, themeId);
      const categoryA = compA ? getCategory(compA.uniqueName) : "Others Components";
      const categoryB = compB ? getCategory(compB.uniqueName) : "Others Components";
      return categoryOrder.indexOf(categoryA) - categoryOrder.indexOf(categoryB);
    });

    for (var i = 0; i < updateArr.length; i++) {
      let comp = getComponentFromUniqueNameAndThemeId(updateArr[i].name, themeId);
      if (comp && comp.component.version) {
        updateArr[i].attributes['version'] = comp.version;
      }

      if (comp) {
        editor.Components.addType(comp.uniqueName, {
          extend: 'react-component',
          model: {
            init() {
              // Older saved layouts can contain an empty traits array; upgrade them on load.
              if (comp.uniqueName === 'HTML Page Handler') {
                htmlPageHandlerDefinition.traits.forEach((trait) => {
                  if (!this.getTrait(trait.name)) this.addTrait({ ...trait });
                });
              }
            },
            defaults: {
              component: comp.component,
              stylable: true,
              resizable: true,
              hoverable: true,
              editable: true,
              draggable: true,
              droppable: true,
              removable: comp.uniqueName !== 'HTML Page Handler',
              copyable: comp.uniqueName !== 'HTML Page Handler',
              attributes: updateArr[i].attributes,
              traits: updateArr[i].traits,
            },
          },
          isComponent: (el) => el.tagName === (updateArr[i] ? comp.uniqueName.toUpperCase() : "M360"),
        });

        let category = getCategory(comp.uniqueName) || CONSTANTS.COMPONENTS_CATEGORY.COMPONENTS;
        
        // The handler is loaded by saved HTML layouts, never dragged into ordinary pages.
        if (comp.uniqueName !== 'HTML Page Handler') editor.BlockManager.add(comp.uniqueName, {
          label: comp.displayName,
          content: { type: comp.uniqueName },
          // category: CONSTANTS.COMPONENTS_CATEGORY.COMPONENTS,
          category: category,
          activate: true,
          media: `<img src=${updateArr[i].media} />`
        })
      }

    }
     // Initialize or refresh the search bar after components are added
    setupBlockSearch(editor);
  });

}
